module.exports = __webpack_public_path__ + "img/logo-senangpay.f4d1e287.svg";